'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Button = _interopDefault(require('@material-ui/core/Button'));
require('../../../../typography/ErrorText/ErrorText.js');
require('../../../../typography/LargeDarkText/LargeDarkText.js');
require('../../../../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../../../../typography/MediumDarkText/MediumDarkText.js');
require('../../../../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../../../../typography/MediumText/MediumText.js');
require('../../../../typography/MediumWhiteText/MediumWhiteText.js');
require('../../../../typography/MiniatureLinkText/MiniatureLinkText.js');
require('../../../../typography/SmallDarkText/SmallDarkText.js');
require('../../../../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../../../../typography/SmallDisabledText/SmallDisabledText.js');
require('../../../../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../../../../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../../../../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
var SmallLinkText = require('../../../../typography/SmallLinkText/SmallLinkText.js');
require('../../../../typography/SmallTitleText/SmallTitleText.js');
require('../../../../typography/SmallWhiteText/SmallWhiteText.js');
require('../../../../typography/TinyDarkText/TinyDarkText.js');
require('../../../../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../../../../typography/TinyLinkText/TinyLinkText.js');
require('../../../../typography/TinyTitleText/TinyTitleText.js');
require('../../../../typography/XXLargeDarkText/XXLargeDarkText.js');
var CircleAvatarWithBadge = require('../../../../buttons/AvatarButtons/CircleAvatarWithBadge/CircleAvatarWithBadge.js');

var AvatarWithResponseButton = function (props) {
    var type = props.type, name = props.name, onClick = props.onClick, _a = props.hideResponse, hideResponse = _a === void 0 ? false : _a;
    return (React__default.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '100%',
        } },
        React__default.createElement("div", { style: { flex: 1, paddingLeft: '12%', paddingTop: '10%' } },
            React__default.createElement(CircleAvatarWithBadge, { type: type, name: name })),
        !hideResponse && (React__default.createElement(Button, { style: {
                flex: 0,
                textTransform: 'none',
                marginLeft: '10%',
                textAlign: 'left',
                marginRight: '20%',
            }, onClick: onClick },
            React__default.createElement(SmallLinkText, { align: 'left' }, "Respond")))));
};

module.exports = AvatarWithResponseButton;
